import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-assurance-credit-professionnel',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent, FormsModule],
  templateUrl: './assurance-credit-professionnel.component.html',
  styleUrls: ['./assurance-credit-professionnel.component.scss']
})
export class AssuranceCreditProfessionnelComponent {
  title = 'Assurance Crédit Professionnel';
  subtitle = '';
  heroVideo = 'assets/videos/credit_prof.mp4';
  breadcrumbs = [
  { label: 'Professionnels', link: undefined },
  { label: 'Crédit Professionnel', link: undefined }
];

  prevPage = { 
    title: 'Assurance Homme-Clé',
    link: '/assurance-homme-cle'
  };

  nextPage = { 
    title: 'Je ne sais pas',
    link: '/autres-assurances'
  };

  formData = {
    prenom: '',
    nom: '',
    email: '',
    telephone: '',
    message: ''
  };

  constructor(private router: Router) {}

  onSubmit(): void {
    if (this.formData.prenom && this.formData.nom && this.formData.email && this.formData.telephone && this.formData.message) {
      console.log('Form submitted:', this.formData);
      // TODO: Implement form submission logic
      alert('Votre demande a été envoyée avec succès !');
      this.clearForm();
    }
  }

  clearForm(): void {
    this.formData = {
      prenom: '',
      nom: '',
      email: '',
      telephone: '',
      message: ''
    };
  }

  navigateToComparison(): void {
    this.router.navigate(['/comparateur']);
  }
}
